/**
 * Buyer Management (page wrapper).
 *
 * Buyer master-data CRUD, previously a tab inside Demand Forecasts.
 * Feb 2026 — relocated to its own route under the Demand nav group,
 * matching the Dispatch Lots pattern (own `App.js` route + own
 * `Layout.js` entry) so operators find it at the same level as
 * "Demand Hub", "Demand Forecasts", and "Dispatch Lots".
 *
 * This file is a thin frame around the existing `BuyerManagementTab`
 * component. The component itself is not modified — it already
 * contains the entire CRUD surface + all `PermButton` gating. The
 * wrapper adds only the page-level chrome (padding, heading) that
 * every other Demand page has.
 *
 * Nav visibility: `Layout.js` gates this route with `entity: 'Buyer'`
 * (`canRead('Buyer')`). `Buyer:READ` is seeded as `*` (wildcard) so
 * every logged-in user sees the nav entry. Write actions inside the
 * page remain gated per-action (CREATE/UPDATE/DELETE) via the
 * `PermButton` wrappers already inside the tab component.
 */
import BuyerManagementTab from "@/components/BuyerManagementTab";

export default function BuyerManagement() {
  return (
    <div className="p-6" data-testid="buyer-management-page">
      <BuyerManagementTab />
    </div>
  );
}
